<div class="tecGym-component book-trainer" [class.is-narrow]="isNarrow">
  <div class="bt-bootstrap" *ngIf="bootstrapLoading" aria-live="polite">
    <div class="bt-bootstrap-card">
      <span class="bt-bootstrap-spinner" aria-hidden="true"></span>
      <p class="bt-bootstrap-title">{{ setLabel('loadingBookTrainerLabel') }}</p>
      <p class="bt-bootstrap-sub">{{ setLabel('loadingBookTrainerHintLabel') }}</p>
    </div>
  </div>

  <div class="bt-body" [class.is-bootstrapping]="bootstrapLoading">
  <p-tabView
    styleClass="bt-tabs"
    [(activeIndex)]="activeTabIndex"
    (onChange)="onTabChange($event)"
  >
    <p-tabPanel [header]="setLabel('bookSessionTabLabel')">
      <div class="bt-shell">
        <!-- Google Calendar–style left sidebar -->
        <aside class="bt-sidebar">
          <button
            type="button"
            class="bt-filters-toggle"
            *ngIf="isNarrow"
            (click)="toggleMobileFilters()"
            [attr.aria-expanded]="mobileFiltersOpen"
          >
            <span>{{ setLabel('filtersToggleLabel') }}</span>
            <i
              class="pi"
              [class.pi-chevron-up]="mobileFiltersOpen"
              [class.pi-chevron-down]="!mobileFiltersOpen"
            ></i>
          </button>
          <div class="bt-sidebar-body" [class.is-collapsed]="isNarrow && !mobileFiltersOpen">
          <div class="bt-brand">
            <span class="bt-brand-icon" aria-hidden="true">
              <i class="pi pi-calendar"></i>
            </span>
            <h2 class="bt-brand-title">{{ setLabel('bookTrainerHeaderLabel') }}</h2>
          </div>

          <p class="bt-hint">{{ setLabel('bookTrainerHintLabel') }}</p>

          <!-- Training service filters -->
          <div class="bt-filter-section">
            <button
              type="button"
              class="bt-filter-head"
              (click)="toggleServicesSection()"
            >
              <span>{{ setLabel('trainingServicesFilterLabel') }}</span>
              <i
                class="pi"
                [class.pi-chevron-up]="servicesSectionOpen"
                [class.pi-chevron-down]="!servicesSectionOpen"
              ></i>
            </button>
            <div class="bt-filter-list" *ngIf="servicesSectionOpen">
              <p
                class="bt-empty bt-filter-empty"
                *ngIf="!trainingServiceOptions.length"
              >
                {{ setLabel('noTrainingServicesHintLabel') }}
              </p>
              <label
                class="bt-check-row bt-check-row--service"
                *ngFor="let svc of trainingServiceOptions"
              >
                <input
                  type="checkbox"
                  [checked]="isServiceChecked(svc.value)"
                  (change)="toggleService(svc.value)"
                />
                <span class="bt-check-box" aria-hidden="true"></span>
                <span class="bt-check-label" [title]="svc.label">{{ svc.label }}</span>
              </label>
            </div>
          </div>

          <!-- Package type filters -->
          <div class="bt-filter-section">
            <button
              type="button"
              class="bt-filter-head"
              (click)="toggleTypesSection()"
            >
              <span>{{ setLabel('packageTypesFilterLabel') }}</span>
              <i
                class="pi"
                [class.pi-chevron-up]="typesSectionOpen"
                [class.pi-chevron-down]="!typesSectionOpen"
              ></i>
            </button>
            <div class="bt-filter-list" *ngIf="typesSectionOpen">
              <label class="bt-check-row bt-check-row--one">
                <input
                  type="checkbox"
                  [checked]="filterOneToOne"
                  (change)="toggleFilterOneToOne()"
                />
                <span class="bt-check-box" aria-hidden="true"></span>
                <span class="bt-check-label">{{ setLabel('oneToOneGroupLabel') }}</span>
              </label>
              <label class="bt-check-row bt-check-row--class">
                <input
                  type="checkbox"
                  [checked]="filterClass"
                  (change)="toggleFilterClass()"
                />
                <span class="bt-check-box" aria-hidden="true"></span>
                <span class="bt-check-label">{{ setLabel('classGroupLabel') }}</span>
              </label>
              <label class="bt-check-row bt-check-row--series">
                <input
                  type="checkbox"
                  [checked]="filterSeries"
                  (change)="toggleFilterSeries()"
                />
                <span class="bt-check-box" aria-hidden="true"></span>
                <span class="bt-check-label">{{ setLabel('seriesGroupBadgeLabel') }}</span>
              </label>
            </div>
          </div>

          <!-- Trainer filters -->
          <div class="bt-filter-section">
            <button
              type="button"
              class="bt-filter-head"
              (click)="toggleTrainersSection()"
            >
              <span>{{ setLabel('trainersFilterLabel') }}</span>
              <i
                class="pi"
                [class.pi-chevron-up]="trainersSectionOpen"
                [class.pi-chevron-down]="!trainersSectionOpen"
              ></i>
            </button>
            <div class="bt-filter-list" *ngIf="trainersSectionOpen">
              <p
                class="bt-empty bt-filter-empty"
                *ngIf="!selectedServiceIds.size"
              >
                {{ setLabel('pickTrainingServiceHintLabel') }}
              </p>
              <p
                class="bt-empty bt-filter-empty"
                *ngIf="selectedServiceIds.size && !anyPackageTypeOn"
              >
                {{ setLabel('pickPackageTypeHintLabel') }}
              </p>
              <p
                class="bt-empty bt-filter-empty"
                *ngIf="selectedServiceIds.size && anyPackageTypeOn && !visibleTrainers.length"
              >
                {{ setLabel('noMatchingTrainersHintLabel') }}
              </p>
              <label
                class="bt-check-row bt-check-row--trainer"
                *ngFor="let t of visibleTrainers"
                [style.--bt-check-color]="t.color"
              >
                <input
                  type="checkbox"
                  [checked]="isTrainerChecked(t.value)"
                  (change)="toggleTrainer(t.value)"
                />
                <span class="bt-check-box" aria-hidden="true"></span>
                <span class="bt-check-label" [title]="t.label">{{ t.label }}</span>
              </label>
            </div>
          </div>

          <p class="bt-empty" *ngIf="!hasCheckedTrainers">
            {{ setLabel('pickTrainerCheckboxHintLabel') }}
          </p>
          </div>
        </aside>

        <!-- Main month calendar -->
        <main class="bt-main">
          <header class="bt-toolbar">
            <div class="bt-toolbar-nav">
              <button
                pButton
                type="button"
                class="p-button-rounded bt-nav-arrow"
                icon="pi pi-chevron-left"
                (click)="prevMonth()"
              ></button>
              <button
                pButton
                type="button"
                class="p-button-rounded bt-nav-today"
                (click)="goToday()"
              >{{ setLabel('todayBtnLabel') }}</button>
              <button
                pButton
                type="button"
                class="p-button-rounded bt-nav-arrow"
                icon="pi pi-chevron-right"
                (click)="nextMonth()"
              ></button>
              <h3 class="bt-toolbar-title">{{
                isNarrow && selectedLocalDate ? selectedDateLabel : calendarTitle
              }}</h3>
            </div>
            <span class="bt-view-pill" *ngIf="!isNarrow">{{ setLabel('monthViewLabel') }}</span>
          </header>

          <div class="bt-cal-wrap" [class.is-loading]="loading || calendarBusy">
            <p class="bt-cal-hint" *ngIf="!hasCheckedTrainers">
              {{ setLabel('pickTrainerCheckboxHintLabel') }}
            </p>
            <full-calendar
              #calendar
              [events]="events"
              [options]="calendarOptions"
            ></full-calendar>
            <div class="bt-cal-busy" *ngIf="calendarBusy" aria-live="polite">
              <span class="bt-bootstrap-spinner" aria-hidden="true"></span>
              <p>{{ setLabel('updatingCalendarLabel') }}</p>
            </div>
          </div>

          <!-- Day detail (selected cell) -->
          <section
            class="bt-day-panel"
            *ngIf="hasCheckedTrainers && selectedLocalDate"
          >
            <div class="bt-row bt-day-detail-toolbar">
              <h3 class="bt-row-title bt-day-title">{{ selectedDateLabel }}</h3>
              <div class="bt-row-actions" *ngIf="!isNarrow">
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-nav-today"
                  icon="pi pi-times"
                  (click)="closeDay()"
                >{{ setLabel('closeDayLabel') }}</button>
              </div>
            </div>

            <p class="bt-empty" *ngIf="!loading && !calendarBusy && !daySeriesCardsList.length && !daySingleSessionsList.length">
              {{ setLabel('noAvailableSessionsLabel') }}
            </p>

            <div class="bt-session-block" *ngFor="let card of daySeriesCardsList; trackBy: trackBySeriesId">
              <div class="bt-row bt-session bt-available bt-session--series">
                <div class="bt-session-meta">
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('trainerColLabel') }}</span>
                    <span class="bt-meta-value">{{ trainerName(card.trainerId) }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionTypeColLabel') }}</span>
                    <div class="bt-type-badge-stack">
                      <span class="bt-session-type-badge bt-session-type-badge--series">{{
                        setLabel('seriesGroupBadgeLabel')
                      }}</span>
                      <span
                        *ngIf="card.monthWise"
                        class="bt-session-type-badge bt-session-type-badge--month"
                      >{{ setLabel('monthWiseBadgeLabel') }}</span>
                    </div>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionPackageColLabel') }}</span>
                    <span class="bt-meta-value">{{ card.packageName }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('seriesScheduleColLabel') }}</span>
                    <span
                      class="bt-meta-value"
                      [title]="seriesScheduleLine(card)"
                    >{{ seriesScheduleLine(card) }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('seriesSessionsColLabel') }}</span>
                    <span class="bt-meta-value">{{
                      card.summary?.sessionCount ?? 0
                    }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionSeatsColLabel') }}</span>
                    <span class="bt-meta-value">{{ card.minSeats }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('priceLabel') }}</span>
                    <span class="bt-meta-value">{{ card.price | number:'1.0-0' }}</span>
                  </div>
                </div>
                <div class="bt-row-actions">
                  <span class="bt-enrolled-badge" *ngIf="isFullyEnrolledInSeries(card.seriesId)">{{
                    setLabel('alreadyEnrolledLabel')
                  }}</span>
                  <button
                    *ngIf="!isFullyEnrolledInSeries(card.seriesId)"
                    type="button"
                    class="p-button p-component p-button-rounded p-button-sm bt-book-btn bt-book-btn--series"
                    (click)="openEnrollDialog(card); $event.stopPropagation()"
                    [disabled]="bookingBusy"
                  >
                    <span class="p-button-icon p-button-icon-left pi pi-check" aria-hidden="true"></span>
                    <span class="p-button-label">{{ setLabel('enrollProgramBtnLabel') }}</span>
                  </button>
                </div>
              </div>
            </div>

            <div
              class="bt-session-block"
              *ngFor="let s of daySingleSessionsList"
            >
              <div
                class="bt-row bt-session bt-available"
                [class.bt-session--one]="isOneToOneSession(s)"
                [class.bt-session--class]="!isOneToOneSession(s)"
              >
                <div class="bt-session-meta">
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('trainerColLabel') }}</span>
                    <span class="bt-meta-value" [title]="trainerName(s.trainerId)">{{
                      trainerName(s.trainerId)
                    }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionTypeColLabel') }}</span>
                    <span
                      class="bt-session-type-badge"
                      [class.bt-session-type-badge--one]="isOneToOneSession(s)"
                      [class.bt-session-type-badge--class]="!isOneToOneSession(s)"
                    >{{ sessionTypeLabel(s) }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionPackageColLabel') }}</span>
                    <span
                      class="bt-meta-value bt-meta-value--pkg"
                      [title]="sessionPackageName(s)"
                      >{{ sessionPackageName(s) }}</span
                    >
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionSlotColLabel') }}</span>
                    <span class="bt-meta-value">{{ sessionWindow(s) }}</span>
                  </div>
                  <div class="bt-meta-col">
                    <span class="bt-meta-label">{{ setLabel('sessionSeatsColLabel') }}</span>
                    <span class="bt-meta-value">{{ s.bookedCount }}/{{ s.maxMembers }}</span>
                  </div>
                </div>
                <div class="bt-row-actions">
                  <button
                    type="button"
                    class="p-button p-component p-button-rounded p-button-sm bt-book-btn"
                    [class.bt-book-btn--one]="isOneToOneSession(s)"
                    [class.bt-book-btn--class]="!isOneToOneSession(s)"
                    (click)="bookSession(s); $event.stopPropagation()"
                    [disabled]="bookingBusy"
                  >
                    <span class="p-button-icon p-button-icon-left pi pi-check" aria-hidden="true"></span>
                    <span class="p-button-label">{{ setLabel('bookBtnLabel') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </p-tabPanel>

    <p-tabPanel [header]="setLabel('allBookingsTabLabel')">
      <div class="bt-all" [class.is-loading]="allBookingsLoading">
        <!-- List: grouped One-to-One / Class -->
        <ng-container *ngIf="!detailBooking && !detailSeriesGroup">
          <p class="bt-all-empty" *ngIf="!allBookingsLoading && !allMemberBookings.length">
            {{ setLabel('noAllBookingsLabel') }}
          </p>

          <section class="bt-all-group bt-all-group--one" *ngIf="oneToOneListCount()">
            <header class="bt-all-group-head">
              <span class="bt-all-badge bt-all-badge--one">1:1</span>
              <h3>{{ setLabel('oneToOneGroupLabel') }}</h3>
              <span class="bt-all-count">{{ oneToOneListCount() }}</span>
            </header>
            <div
              class="bt-all-card bt-all-card--one"
              *ngFor="let g of oneToOneSharedGroups(); trackBy: trackBySeriesGroup"
              (click)="openSeriesGroupDetail(g)"
            >
              <div class="bt-all-card-body">
                <p class="bt-all-card-title">{{ g.packageName }}</p>
                <p class="bt-all-card-meta">
                  <span>{{ trainerName(g.trainerId) }}</span>
                  <span class="bt-all-dot">·</span>
                  <span>{{ g.bookings.length }} {{ setLabel('seriesSessionsColLabel') }}</span>
                  <span class="bt-all-dot" *ngIf="groupHasFeeBalance(g)">·</span>
                  <span class="bt-fee-balance-badge" *ngIf="groupHasFeeBalance(g)">{{
                    setLabel('paymentRemainingBadgeLabel').replace(
                      '{amount}',
                      '' + feeBalance(feeById.get(g.feeId!)!)
                    )
                  }}</span>
                </p>
              </div>
              <div class="bt-all-card-actions">
                <button
                  *ngIf="groupHasFeeBalance(g)"
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-pay-btn"
                  icon="pi pi-wallet"
                  (click)="openPayRemainingForGroup(g); $event.stopPropagation()"
                >{{ setLabel('payRemainingBtnLabel') }}</button>
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-detail-btn"
                  icon="pi pi-eye"
                  (click)="openSeriesGroupDetail(g); $event.stopPropagation()"
                >{{ setLabel('showDetailBtnLabel') }}</button>
              </div>
            </div>
            <div
              class="bt-all-card bt-all-card--one"
              *ngFor="let b of oneToOneBookings()"
            >
              <div class="bt-all-card-body">
                <p class="bt-all-card-title">{{ allBookingTitle(b) }}</p>
                <p class="bt-all-card-meta">
                  <span>{{ trainerName(b.trainerId) }}</span>
                  <span class="bt-all-dot">·</span>
                  <span class="bt-all-status" [attr.data-status]="b.status">{{
                    bookingStatusLabel(b.status)
                  }}</span>
                  <span class="bt-all-dot" *ngIf="bookingHasFeeBalance(b)">·</span>
                  <span class="bt-fee-balance-badge" *ngIf="bookingHasFeeBalance(b)">{{
                    setLabel('paymentRemainingBadgeLabel').replace(
                      '{amount}',
                      '' + feeBalance(feeForBooking(b)!)
                    )
                  }}</span>
                </p>
              </div>
              <div class="bt-all-card-actions">
                <button
                  *ngIf="bookingHasFeeBalance(b)"
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-pay-btn"
                  icon="pi pi-wallet"
                  (click)="openPayRemainingForBooking(b); $event.stopPropagation()"
                >{{ setLabel('payRemainingBtnLabel') }}</button>
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-detail-btn"
                  icon="pi pi-eye"
                  (click)="openBookingDetail(b)"
                >{{ setLabel('showDetailBtnLabel') }}</button>
              </div>
            </div>
          </section>

          <section class="bt-all-group bt-all-group--series" *ngIf="seriesGroups.length">
            <header class="bt-all-group-head">
              <span class="bt-all-badge bt-all-badge--series">{{
                setLabel('seriesGroupBadgeLabel')
              }}</span>
              <h3>{{ setLabel('seriesEnrollmentsGroupLabel') }}</h3>
              <span class="bt-all-count">{{ seriesGroups.length }}</span>
            </header>
            <div
              class="bt-all-card bt-all-card--series"
              *ngFor="let g of seriesGroups; trackBy: trackBySeriesGroup"
              (click)="openSeriesGroupDetail(g)"
            >
              <div class="bt-all-card-body">
                <p class="bt-all-card-title">{{ g.packageName }}</p>
                <p class="bt-all-card-meta">
                  <span>{{ trainerName(g.trainerId) }}</span>
                  <span class="bt-all-dot">·</span>
                  <span>{{ g.bookings.length }} {{ setLabel('seriesSessionsColLabel') }}</span>
                  <span class="bt-all-dot" *ngIf="groupHasFeeBalance(g)">·</span>
                  <span class="bt-fee-balance-badge" *ngIf="groupHasFeeBalance(g)">{{
                    setLabel('paymentRemainingBadgeLabel').replace(
                      '{amount}',
                      '' + feeBalance(feeById.get(g.feeId!)!)
                    )
                  }}</span>
                </p>
              </div>
              <div class="bt-all-card-actions">
                <button
                  *ngIf="groupHasFeeBalance(g)"
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-pay-btn"
                  icon="pi pi-wallet"
                  (click)="openPayRemainingForGroup(g); $event.stopPropagation()"
                >{{ setLabel('payRemainingBtnLabel') }}</button>
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-detail-btn bt-all-detail-btn--series"
                  icon="pi pi-eye"
                  (click)="openSeriesGroupDetail(g)"
                >{{ setLabel('showDetailBtnLabel') }}</button>
              </div>
            </div>
          </section>

          <section class="bt-all-group bt-all-group--class" *ngIf="classListCount()">
            <header class="bt-all-group-head">
              <span class="bt-all-badge bt-all-badge--class">{{
                setLabel('classGroupLabel')
              }}</span>
              <h3>{{ setLabel('classGroupLabel') }}</h3>
              <span class="bt-all-count">{{ classListCount() }}</span>
            </header>
            <div
              class="bt-all-card bt-all-card--class"
              *ngFor="let g of classSharedGroups(); trackBy: trackBySeriesGroup"
              (click)="openSeriesGroupDetail(g)"
            >
              <div class="bt-all-card-body">
                <p class="bt-all-card-title">{{ g.packageName }}</p>
                <p class="bt-all-card-meta">
                  <span>{{ trainerName(g.trainerId) }}</span>
                  <span class="bt-all-dot">·</span>
                  <span>{{ g.bookings.length }} {{ setLabel('seriesSessionsColLabel') }}</span>
                  <span class="bt-all-dot" *ngIf="groupHasFeeBalance(g)">·</span>
                  <span class="bt-fee-balance-badge" *ngIf="groupHasFeeBalance(g)">{{
                    setLabel('paymentRemainingBadgeLabel').replace(
                      '{amount}',
                      '' + feeBalance(feeById.get(g.feeId!)!)
                    )
                  }}</span>
                </p>
              </div>
              <div class="bt-all-card-actions">
                <button
                  *ngIf="groupHasFeeBalance(g)"
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-pay-btn"
                  icon="pi pi-wallet"
                  (click)="openPayRemainingForGroup(g); $event.stopPropagation()"
                >{{ setLabel('payRemainingBtnLabel') }}</button>
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-detail-btn bt-all-detail-btn--class"
                  icon="pi pi-eye"
                  (click)="openSeriesGroupDetail(g); $event.stopPropagation()"
                >{{ setLabel('showDetailBtnLabel') }}</button>
              </div>
            </div>
            <div
              class="bt-all-card bt-all-card--class"
              *ngFor="let b of singleClassBookings()"
            >
              <div class="bt-all-card-body">
                <p class="bt-all-card-title">{{ allBookingTitle(b) }}</p>
                <p class="bt-all-card-meta">
                  <span>{{ trainerName(b.trainerId) }}</span>
                  <span class="bt-all-dot">·</span>
                  <span class="bt-all-status" [attr.data-status]="b.status">{{
                    bookingStatusLabel(b.status)
                  }}</span>
                  <span class="bt-all-dot" *ngIf="bookingHasFeeBalance(b)">·</span>
                  <span class="bt-fee-balance-badge" *ngIf="bookingHasFeeBalance(b)">{{
                    setLabel('paymentRemainingBadgeLabel').replace(
                      '{amount}',
                      '' + feeBalance(feeForBooking(b)!)
                    )
                  }}</span>
                </p>
              </div>
              <div class="bt-all-card-actions">
                <button
                  *ngIf="bookingHasFeeBalance(b)"
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-pay-btn"
                  icon="pi pi-wallet"
                  (click)="openPayRemainingForBooking(b); $event.stopPropagation()"
                >{{ setLabel('payRemainingBtnLabel') }}</button>
                <button
                  pButton
                  type="button"
                  class="p-button-rounded p-button-sm bt-all-detail-btn bt-all-detail-btn--class"
                  icon="pi pi-eye"
                  (click)="openBookingDetail(b)"
                >{{ setLabel('showDetailBtnLabel') }}</button>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- Detail: program enrollment — all sessions + attendance -->
        <section class="bt-all-detail" *ngIf="detailSeriesGroup as g">
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-sm bt-all-back"
            [class.bt-all-back--one]="sharedGroupTone(g) === 'one_to_one'"
            [class.bt-all-back--class]="sharedGroupTone(g) === 'class'"
            [class.bt-all-back--series]="sharedGroupTone(g) === 'series'"
            icon="pi pi-arrow-left"
            (click)="closeBookingDetail()"
          >{{ setLabel('backToListBtnLabel') }}</button>

          <div
            class="bt-all-detail-card"
            [class.bt-all-detail-card--one]="sharedGroupTone(g) === 'one_to_one'"
            [class.bt-all-detail-card--class]="sharedGroupTone(g) === 'class'"
            [class.bt-all-detail-card--series]="sharedGroupTone(g) === 'series'"
          >
            <div class="bt-all-detail-top">
              <span
                class="bt-all-badge"
                [class.bt-all-badge--one]="sharedGroupTone(g) === 'one_to_one'"
                [class.bt-all-badge--class]="sharedGroupTone(g) === 'class'"
                [class.bt-all-badge--series]="sharedGroupTone(g) === 'series'"
              >{{ sharedGroupBadgeLabel(g) }}</span>
              <span class="bt-all-count">{{ g.bookings.length }}</span>
            </div>
            <h3 class="bt-all-detail-title">{{ g.packageName }}</h3>
            <div class="bt-all-detail-grid">
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('trainerColLabel') }}</span>
                <span class="bt-all-detail-value">{{ trainerName(g.trainerId) }}</span>
              </div>
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('seriesSessionsColLabel') }}</span>
                <span class="bt-all-detail-value">{{ g.bookings.length }}</span>
              </div>
            </div>
            <ul class="bt-series-detail-list">
              <li class="bt-series-detail-head">
                <span>{{ setLabel('dateLabel') }}</span>
                <span>{{ setLabel('sessionSlotColLabel') }}</span>
                <span>{{ setLabel('statusLabel') }}</span>
              </li>
              <li
                class="bt-series-detail-row"
                *ngFor="let b of g.bookings"
              >
                <span>{{ allBookingDate(b) }}</span>
                <span>{{ allBookingSlot(b) }}</span>
                <span class="bt-all-status" [attr.data-status]="b.status">{{
                  bookingStatusLabel(b.status)
                }}</span>
              </li>
            </ul>
          </div>
        </section>

        <!-- Detail: one booking only -->
        <section class="bt-all-detail" *ngIf="detailBooking as b">
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-sm bt-all-back"
            [class.bt-all-back--one]="bookingTone(b) === 'one_to_one'"
            [class.bt-all-back--class]="bookingTone(b) === 'class'"
            [class.bt-all-back--series]="bookingTone(b) === 'series'"
            icon="pi pi-arrow-left"
            (click)="closeBookingDetail()"
          >{{ setLabel('backToListBtnLabel') }}</button>

          <div
            class="bt-all-detail-card"
            [class.bt-all-detail-card--one]="bookingTone(b) === 'one_to_one'"
            [class.bt-all-detail-card--class]="bookingTone(b) === 'class'"
            [class.bt-all-detail-card--series]="bookingTone(b) === 'series'"
          >
            <div class="bt-all-detail-top">
              <span
                class="bt-all-badge"
                [class.bt-all-badge--one]="bookingTone(b) === 'one_to_one'"
                [class.bt-all-badge--class]="bookingTone(b) === 'class'"
                [class.bt-all-badge--series]="bookingTone(b) === 'series'"
              >
                {{ bookingToneLabel(b) }}
              </span>
              <span class="bt-all-status" [attr.data-status]="b.status">{{
                bookingStatusLabel(b.status)
              }}</span>
            </div>

            <h3 class="bt-all-detail-title">{{ allBookingPackageName(b) }}</h3>

            <div class="bt-all-detail-grid">
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('trainerColLabel') }}</span>
                <span class="bt-all-detail-value">{{ trainerName(b.trainerId) }}</span>
              </div>
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('dateLabel') }}</span>
                <span class="bt-all-detail-value">{{ allBookingDate(b) }}</span>
              </div>
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('sessionSlotColLabel') }}</span>
                <span class="bt-all-detail-value">{{ allBookingSlot(b) }}</span>
              </div>
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('sessionSeatsColLabel') }}</span>
                <span class="bt-all-detail-value">{{ allBookingSeats(b) }}</span>
              </div>
              <div class="bt-all-detail-item">
                <span class="bt-all-detail-label">{{ setLabel('statusLabel') }}</span>
                <span class="bt-all-detail-value">{{ bookingStatusLabel(b.status) }}</span>
              </div>
            </div>

            <div class="bt-all-detail-actions" *ngIf="b.status === 'confirmed'">
              <button
                pButton
                type="button"
                class="p-button-rounded p-button-sm bt-all-cancel"
                icon="pi pi-times"
                (click)="cancelBooking(b)"
                [disabled]="cancellingId === b._id"
              >{{ setLabel('cancelBookingBtnLabel') }}</button>
            </div>
          </div>
        </section>
      </div>
    </p-tabPanel>

    <p-tabPanel [header]="setLabel('feeHistoryTabLabel')">
      <div class="bt-fees" [class.is-loading]="feeHistoryLoading">
        <div class="bt-fee-filters">
          <div class="bt-fee-filter-field">
            <label for="btFeeFrom">{{ setLabel('feeFilterFromLabel') }}</label>
            <p-calendar
              inputId="btFeeFrom"
              [(ngModel)]="feeHistoryFrom"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [maxDate]="feeHistoryTo || undefined"
              (onSelect)="onFeeHistoryDateFilterChange()"
              appendTo="body"
              [style]="{ width: '100%' }"
            ></p-calendar>
          </div>
          <div class="bt-fee-filter-field">
            <label for="btFeeTo">{{ setLabel('feeFilterToLabel') }}</label>
            <p-calendar
              inputId="btFeeTo"
              [(ngModel)]="feeHistoryTo"
              dateFormat="dd/mm/yy"
              [showIcon]="true"
              [minDate]="feeHistoryFrom || undefined"
              (onSelect)="onFeeHistoryDateFilterChange()"
              appendTo="body"
              [style]="{ width: '100%' }"
            ></p-calendar>
          </div>
        </div>

        <p class="bt-all-empty" *ngIf="!feeHistoryLoading && !feeHistoryAllRows.length">
          {{ setLabel('noFeeHistoryLabel') }}
        </p>
        <p
          class="bt-all-empty"
          *ngIf="
            !feeHistoryLoading &&
            feeHistoryAllRows.length &&
            !filteredFeeHistoryRows.length
          "
        >
          {{ setLabel('noFeeHistoryInRangeLabel') }}
        </p>

        <div class="bt-fee-list" *ngIf="filteredFeeHistoryRows.length">
          <div class="bt-fee-table" [class.bt-fee-table--with-tax]="showFeeTaxColumn">
            <div class="bt-fee-cols-head">
              <span class="bt-fee-col">{{ setLabel('feeInvoiceLabel') }}</span>
              <span class="bt-fee-col">{{ setLabel('feeBaseLabel') }}</span>
              <span class="bt-fee-col">{{ setLabel('feeDiscountLabel') }}</span>
              <span class="bt-fee-col" *ngIf="showFeeTaxColumn">{{ setLabel('feeTaxLabel') }}</span>
              <span class="bt-fee-col">{{ setLabel('feePaymentModeLabel') }}</span>
              <span class="bt-fee-col">{{ setLabel('feeDateLabel') }}</span>
              <span class="bt-fee-col bt-fee-col--center">{{ setLabel('feeCommentLabel') }}</span>
              <span class="bt-fee-col bt-fee-col--center">{{ setLabel('actionsLabel') }}</span>
            </div>

            <article
              class="bt-fee-card"
              *ngFor="let fee of pagedFeeHistoryRows"
              [class.bt-fee-card--one]="feeKind(fee) === 'one_to_one'"
              [class.bt-fee-card--class]="feeKind(fee) === 'class'"
              [class.bt-fee-card--series]="feeKind(fee) === 'series'"
            >
              <div class="bt-fee-card-top">
                <div class="bt-fee-card-main">
                  <h3 class="bt-fee-card-title">
                    {{ feePackageName(fee) }}
                    <span class="bt-fee-pkg-kind">({{ feeKindLabel(fee) }})</span>
                    <span
                      class="bt-fee-split-badge"
                      *ngIf="feeSplitPartLabel(fee) as splitLabel"
                      [pTooltip]="setLabel('splitPartTooltipLabel')"
                      tooltipPosition="top"
                      >{{ splitLabel }}</span
                    >
                    <span
                      class="bt-fee-followup-badge"
                      *ngIf="isFeeChildRow(fee)"
                      [pTooltip]="setLabel('payRemainingChildTooltipLabel')"
                      tooltipPosition="top"
                      >{{ setLabel('payRemainingChildBadgeLabel') }}</span
                    >
                    <span class="bt-fee-balance-badge" *ngIf="hasFeeBalance(fee)">{{
                      setLabel('paymentRemainingBadgeLabel').replace(
                        '{amount}',
                        '' + feeBalance(fee)
                      )
                    }}</span>
                  </h3>
                  <p class="bt-fee-card-meta">
                    <span class="bt-fee-trainer-pill">{{ trainerName(fee.trainerId) }}</span>
                  </p>
                </div>
                <div class="bt-fee-card-total-wrap">
                  <button
                    *ngIf="hasFeeBalance(fee)"
                    type="button"
                    class="bt-fee-icon-btn bt-fee-icon-btn--pay"
                    (click)="openPayRemainingDialog(fee)"
                    [pTooltip]="setLabel('payRemainingBtnLabel')"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-wallet" aria-hidden="true"></i>
                  </button>
                  <div class="bt-fee-card-total">
                    <span class="bt-fee-card-total-label">{{ setLabel('feeTotalLabel') }}</span>
                    <span class="bt-fee-card-total-value">{{ fee.totalPaid }}</span>
                  </div>
                </div>
              </div>

              <div class="bt-fee-chip-row bt-fee-chip-row--values">
                <div class="bt-fee-col bt-fee-chip bt-fee-chip--invoice">
                  <span class="bt-fee-chip-label">{{ setLabel('feeInvoiceLabel') }}</span>
                  <span class="bt-fee-chip-value" [title]="fee.invoice || ''">{{ fee.invoice || '—' }}</span>
                </div>
                <div class="bt-fee-col bt-fee-chip">
                  <span class="bt-fee-chip-label">{{ setLabel('feeBaseLabel') }}</span>
                  <span class="bt-fee-chip-value">{{ fee.baseAmount }}</span>
                </div>
                <div class="bt-fee-col bt-fee-chip">
                  <span class="bt-fee-chip-label">{{ setLabel('feeDiscountLabel') }}</span>
                  <span class="bt-fee-chip-value">{{ fee.discount }}</span>
                </div>
                <div class="bt-fee-col bt-fee-chip" *ngIf="showFeeTaxColumn">
                  <span class="bt-fee-chip-label">{{ setLabel('feeTaxLabel') }}</span>
                  <span class="bt-fee-chip-value">{{ fee.tax }}</span>
                </div>
                <div class="bt-fee-col bt-fee-chip bt-fee-chip--mode">
                  <span class="bt-fee-chip-label">{{ setLabel('feePaymentModeLabel') }}</span>
                  <span class="bt-fee-chip-value" [title]="fee.paymentMode || ''">{{ fee.paymentMode }}</span>
                </div>
                <div class="bt-fee-col bt-fee-chip bt-fee-chip--date">
                  <span class="bt-fee-chip-label">{{ setLabel('feeDateLabel') }}</span>
                  <span class="bt-fee-chip-value">{{ feeDateLabel(fee) }}</span>
                </div>
                <div class="bt-fee-col bt-fee-col--center bt-fee-chip bt-fee-chip--icon">
                  <span class="bt-fee-chip-label">{{ setLabel('feeCommentLabel') }}</span>
                  <button
                    type="button"
                    class="bt-fee-icon-btn"
                    [class.has-comment]="!!fee.description"
                    (click)="openFeeCommentDialog(fee)"
                    [pTooltip]="setLabel('feeCommentLabel')"
                    tooltipPosition="top"
                  >
                    <i class="pi pi-comment" aria-hidden="true"></i>
                  </button>
                </div>
                <div class="bt-fee-col bt-fee-col--center bt-fee-chip bt-fee-chip--actions">
                  <span class="bt-fee-chip-label">{{ setLabel('actionsLabel') }}</span>
                  <div class="bt-fee-chip-actions">
                    <a
                      *ngIf="fee.feeReceiptImageUrl"
                      class="bt-fee-icon-btn"
                      [href]="receiptUrl(fee.feeReceiptImageUrl)"
                      target="_blank"
                      rel="noopener"
                      [pTooltip]="setLabel('viewReceiptLabel')"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-image" aria-hidden="true"></i>
                    </a>
                    <button
                      type="button"
                      class="bt-fee-icon-btn"
                      (click)="printFeeReceipt(fee)"
                      [pTooltip]="setLabel('printFeeBtnLabel')"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-print" aria-hidden="true"></i>
                    </button>
                    <button
                      *ngIf="canDeleteTrainerFee() && !isFeeChildRow(fee)"
                      type="button"
                      class="bt-fee-icon-btn bt-fee-icon-btn--danger"
                      (click)="deleteFeeRecord(fee)"
                      [disabled]="deletingFeeId === fee._id"
                      [pTooltip]="setLabel('deleteFeeBtnLabel')"
                      tooltipPosition="top"
                    >
                      <i class="pi pi-trash" aria-hidden="true"></i>
                    </button>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <div
            class="bt-fee-pager"
            *ngIf="filteredFeeHistoryRows.length > feeHistoryPageSize"
          >
            <button
              pButton
              type="button"
              class="p-button-rounded p-button-sm p-button-text bt-fee-pager-btn"
              icon="pi pi-chevron-left"
              (click)="prevFeeHistoryPage()"
              [disabled]="!canPrevFeeHistoryPage"
            ></button>
            <span class="bt-fee-pager-info">{{ feeHistoryPageInfo }}</span>
            <button
              pButton
              type="button"
              class="p-button-rounded p-button-sm p-button-text bt-fee-pager-btn"
              icon="pi pi-chevron-right"
              (click)="nextFeeHistoryPage()"
              [disabled]="!canNextFeeHistoryPage"
            ></button>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
  </div>

  <p-dialog
  styleClass="bt-clay-dialog"
  appendTo="body"
  [header]="bookDialogHeader"
  [(visible)]="bookDialogVisible"
  [modal]="true"
  [style]="{ width: multiplePaymentModesEnabled ? '760px' : '600px' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="closeBookDialog()"
>
  <div class="bt-book-dialog" *ngIf="isSeriesBookMode ? enrollTarget : bookTarget">
    <ng-container *ngIf="isSeriesBookMode; else singleSessionHead">
    <p class="bt-hint">{{
      showEnrollMonthPicker
        ? setLabel('selectProgramMonthsLabel')
        : setLabel('enrollProgramHintLabel')
    }}</p>
    <p class="bt-fee-error" *ngIf="enrollDialogMinSeats <= 0">{{
      setLabel('seriesFullLabel')
    }}</p>

    <div class="bt-dialog-meta bt-dialog-meta--series">
      <div class="bt-meta-col">
        <span class="bt-meta-label">{{ setLabel('sessionTypeColLabel') }}</span>
        <div class="bt-type-badge-stack">
          <span class="bt-session-type-badge bt-session-type-badge--series">{{
            setLabel('seriesGroupBadgeLabel')
          }}</span>
          <span
            *ngIf="enrollMonthWise || enrollTarget.monthWise"
            class="bt-session-type-badge bt-session-type-badge--month"
          >{{ setLabel('monthWiseBadgeLabel') }}</span>
        </div>
      </div>
      <div class="bt-meta-col">
        <span class="bt-meta-label">{{ setLabel('sessionPackageColLabel') }}</span>
        <span class="bt-meta-value" [title]="enrollTarget.packageName">{{
          enrollTarget.packageName
        }}</span>
      </div>
      <div class="bt-meta-col">
        <span class="bt-meta-label">{{ setLabel('seriesSessionsColLabel') }}</span>
        <span class="bt-meta-value">{{ enrollDialogSessions.length }}</span>
      </div>
      <div class="bt-meta-col">
        <span class="bt-meta-label">{{ setLabel('sessionSeatsColLabel') }}</span>
        <span class="bt-meta-value">{{ enrollDialogMinSeats }}</span>
      </div>
      <div class="bt-meta-col bt-meta-col--schedule">
        <div class="bt-schedule-parts">
          <div class="bt-schedule-part">
            <span class="bt-meta-label">{{ setLabel('seriesDaysColLabel') }}</span>
            <span class="bt-meta-value" [title]="seriesWeekdaysLine(enrollTarget)">{{
              seriesWeekdaysLine(enrollTarget)
            }}</span>
          </div>
          <div class="bt-schedule-part">
            <span class="bt-meta-label">{{ setLabel('seriesSlotColLabel') }}</span>
            <span class="bt-meta-value">{{ seriesSlotTime(enrollTarget) }}</span>
          </div>
          <div class="bt-schedule-part">
            <span class="bt-meta-label">{{ setLabel('seriesDatesColLabel') }}</span>
            <span class="bt-meta-value" [title]="seriesDateRange(enrollTarget)">{{
              seriesDateRange(enrollTarget)
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <section class="bt-book-section">
      <div class="bt-publish-row">
        <label>{{ setLabel('sessionPackageColLabel') }}</label>
        <div class="bt-readonly-pill">{{ bookClassPackageLabel }}</div>
      </div>
      <div class="bt-publish-row bt-same-slot-row" *ngIf="showEnrollMonthPicker">
        <label>{{ setLabel('selectProgramMonthsLabel') }}</label>
        <div class="bt-enroll-month-ms-wrap bt-same-slot-ms-wrap bt-same-slot-ms-wrap--series">
          <button
            type="button"
            class="bt-same-slot-trigger"
            [disabled]="bookingBusy"
            (click)="toggleEnrollMonthPanel($event)"
          >
            <span class="bt-same-slot-trigger-label">{{ enrollMonthTriggerLabel }}</span>
            <span class="pi pi-chevron-down"></span>
          </button>
          <div
            class="bt-same-slot-panel"
            *ngIf="enrollMonthPanelOpen"
            (click)="$event.stopPropagation()"
          >
            <div
              *ngFor="let opt of enrollMonthOptions"
              class="bt-same-slot-opt"
              [class.is-on]="isEnrollMonthSelected(opt.key)"
              (click)="onEnrollMonthRowClick(opt.key)"
            >
              <input
                class="bt-same-slot-check"
                type="checkbox"
                [checked]="isEnrollMonthSelected(opt.key)"
                [disabled]="bookingBusy"
                tabindex="-1"
              />
              <span class="bt-same-slot-date">{{ opt.label }}</span>
            </div>
          </div>
        </div>
        <p class="bt-hint">{{ setLabel('remainingProgramMonthsHintLabel') }}</p>
      </div>
    </section>
    </ng-container>

    <ng-template #singleSessionHead>
    <div class="bt-dialog-meta">
      <div class="bt-meta-col">
        <span class="bt-meta-label">{{ setLabel('sessionTypeColLabel') }}</span>
        <span class="bt-meta-value">{{ sessionDisplayName(bookTarget) }}</span>
      </div>
      <div class="bt-meta-col bt-meta-col--time">
        <span class="bt-meta-label">{{ setLabel('sessionSlotColLabel') }}</span>
        <span class="bt-meta-value bt-meta-value--time" [title]="sessionWindow(bookTarget)">{{
          sessionWindow(bookTarget)
        }}</span>
      </div>
      <div class="bt-meta-col bt-meta-col--seats">
        <span class="bt-meta-label">{{ setLabel('sessionSeatsColLabel') }}</span>
        <span class="bt-meta-value">
          {{ bookTarget.bookedCount }}/{{ bookTarget.maxMembers }}
        </span>
      </div>
    </div>

    <section class="bt-book-section">
      <ng-container *ngIf="isOneToOneSession(bookTarget); else classPkgBlock">
        <p class="bt-hint">{{ setLabel('oneToOnePickPackageHintLabel') }}</p>
        <div class="bt-publish-row">
          <label for="btPkg">{{ setLabel('selectOneToOnePackageLabel') }}</label>
          <p-dropdown
            id="btPkg"
            class="bt-pkg-dd"
            [panelStyleClass]="bookDdPanelClass"
            [options]="oneToOnePackageOptions"
            [(ngModel)]="bookPackageId"
            (onChange)="onBookPackageChange()"
            [placeholder]="setLabel('selectOneToOnePackagePlaceholderLabel')"
            appendTo="body"
            [style]="{ width: '100%' }"
            [disabled]="bookingBusy"
          ></p-dropdown>
        </div>
      </ng-container>
      <ng-template #classPkgBlock>
        <div class="bt-publish-row">
          <label>{{ setLabel('sessionPackageColLabel') }}</label>
          <div class="bt-readonly-pill">{{ bookClassPackageLabel }}</div>
        </div>
      </ng-template>
    </section>
    <section class="bt-book-section" *ngIf="showSameSlotMultiSelect">
      <div class="bt-publish-row bt-same-slot-row">
        <label>{{ setLabel('sameSlotAlsoBookLabel') }}</label>
        <div
          class="bt-same-slot-ms-wrap"
          [class.bt-same-slot-ms-wrap--one]="bookTone === 'one'"
          [class.bt-same-slot-ms-wrap--class]="bookTone === 'class'"
          [class.bt-same-slot-ms-wrap--series]="bookTone === 'series'"
        >
          <button
            type="button"
            class="bt-same-slot-trigger"
            [disabled]="bookingBusy"
            (click)="toggleSameSlotPanel($event)"
          >
            <span class="bt-same-slot-trigger-label">{{ sameSlotTriggerLabel }}</span>
            <span class="pi pi-chevron-down"></span>
          </button>
          <div
            class="bt-same-slot-panel"
            *ngIf="sameSlotPanelOpen"
            (click)="$event.stopPropagation()"
          >
            <div
              class="bt-same-slot-opt bt-same-slot-all"
              [class.is-on]="allSameSlotsSelected"
              (click)="toggleAllSameSlots()"
            >
              <input
                class="bt-same-slot-check"
                type="checkbox"
                [checked]="allSameSlotsSelected"
                tabindex="-1"
              />
              <span class="bt-same-slot-date">{{ setLabel('sameSlotSelectAllLabel') }} ({{ sameSlotSessionOptions.length }})</span>
            </div>
            <div
              *ngFor="let opt of sameSlotSessionOptions"
              class="bt-same-slot-opt"
              [class.is-on]="isSameSlotSelected(opt.value)"
              [class.is-seed]="isSameSlotSeed(opt.value)"
              (click)="onSameSlotRowClick(opt.value)"
            >
              <input
                class="bt-same-slot-check"
                type="checkbox"
                [checked]="isSameSlotSelected(opt.value)"
                [disabled]="bookingBusy || isSameSlotSeed(opt.value)"
                tabindex="-1"
              />
              <span class="bt-same-slot-date">{{ opt.label }}</span>
            </div>
          </div>
        </div>
        <p class="bt-hint">{{
          setLabel('sameSlotSelectedCountLabel').replace(
            '{count}',
            '' + selectedBookSessionIds.length
          )
        }}</p>
      </div>
    </section>
    </ng-template>

    <section class="bt-fee-form">
      <header class="bt-fee-form-head">
        <span class="bt-fee-form-title">{{ setLabel('feeSectionLabel') }}</span>
      </header>

      <p class="bt-hint" *ngIf="isSeriesBookMode">{{
        enrollPriceHint
      }}</p>

      <div class="bt-fee-grid">
        <div class="bt-publish-row bt-fee-cell">
          <label for="btFee">{{ setLabel('feeBaseLabel') }}</label>
          <input
            id="btFee"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            class="bt-fee-input"
            [class.bt-fee-input--error]="bookPayNowError"
            [ngModel]="bookPayNow"
            (ngModelChange)="onBookPayNowChange($event)"
            [disabled]="bookingBusy"
          />
          <small class="bt-fee-error" *ngIf="bookPayNowError">{{
            bookPayNowErrorLabel
          }}</small>
        </div>
        <div class="bt-publish-row bt-fee-cell">
          <label for="btDisc">{{ setLabel('feeDiscountLabel') }}</label>
          <input
            id="btDisc"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            class="bt-fee-input"
            [class.bt-fee-input--error]="bookDiscountError"
            [ngModel]="bookDiscount"
            (ngModelChange)="onBookDiscountChange($event)"
            [disabled]="bookingBusy"
          />
          <small class="bt-fee-error" *ngIf="bookDiscountError">{{
            setLabel('discountInvalidLabel')
          }}</small>
        </div>
      </div>

      <div class="bt-publish-row bt-multipay-toggle">
        <label>{{ setLabel('multiplePaymentModesLabel') }}</label>
        <p-inputSwitch
          name="bookMultiplePaymentModes"
          [(ngModel)]="multiplePaymentModesEnabled"
          (onChange)="onMultiplePaymentModesToggle($event.checked)"
          [disabled]="bookingBusy"
        ></p-inputSwitch>
      </div>

      <div class="bt-publish-row" *ngIf="!multiplePaymentModesEnabled">
        <label for="btPay">{{ setLabel('feePaymentModeLabel') }}</label>
        <p-dropdown
          id="btPay"
          class="bt-pkg-dd"
          [panelStyleClass]="bookDdPanelClass"
          [options]="paymentOptions"
          [(ngModel)]="bookPaymentMode"
          (onChange)="onBookPaymentModeChange()"
          appendTo="body"
          [style]="{ width: '100%' }"
          [disabled]="bookingBusy"
        ></p-dropdown>
      </div>

      <div class="bt-split-section" *ngIf="multiplePaymentModesEnabled">
        <div class="bt-split-header">
          <span>{{ setLabel('paymentColumnLabel') }}</span>
          <span>{{ setLabel('amountLabel') }}</span>
          <span>{{ setLabel('feeTaxLabel') }}</span>
          <span>{{ setLabel('subTotalLabel') }}</span>
          <span></span>
        </div>
        <div
          class="bt-split-row"
          *ngFor="let row of paymentSplits; trackBy: trackSplitRowById"
        >
          <p-dropdown
            class="bt-pkg-dd bt-split-mode-dd"
            [options]="paymentOptions"
            [name]="'splitMode_' + row.id"
            [(ngModel)]="row.paymentMode"
            appendTo="body"
            [placeholder]="setLabel('feePaymentModeLabel')"
            (onChange)="onSplitPaymentModeChange(row, $event?.value ?? row.paymentMode)"
            [disabled]="bookingBusy"
          ></p-dropdown>
          <input
            type="number"
            class="bt-fee-input bt-split-amount"
            [name]="'splitPay_' + row.id"
            [ngModel]="row.pay"
            min="0"
            [placeholder]="setLabel('amountLabel')"
            (ngModelChange)="onSplitPayChange(row, $event)"
            [disabled]="bookingBusy"
          />
          <span class="bt-split-tax bt-readonly-pill">
            <ng-container *ngIf="row.taxType === 'INCLUDING_TAX' && row.includedTax">
              {{ row.includedTax | number:'1.0-0' }}
            </ng-container>
            <ng-container *ngIf="row.taxType !== 'INCLUDING_TAX' || !row.includedTax">
              {{ row.tax | number:'1.0-0' }}
            </ng-container>
          </span>
          <span class="bt-split-total">{{ row.lineTotal | number:'1.0-0' }}</span>
          <button
            type="button"
            class="bt-split-remove"
            (click)="removePaymentSplitRow(row.id)"
            [disabled]="paymentSplits.length <= 2 || bookingBusy"
            [pTooltip]="
              paymentSplits.length <= 2
                ? setLabel('minTwoPaymentModesTooltipLabel')
                : setLabel('removePaymentModeTooltipLabel')
            "
            tooltipPosition="top"
            aria-label="Remove"
          >
            <i class="pi pi-times" aria-hidden="true"></i>
          </button>
        </div>
        <button
          type="button"
          class="bt-split-add"
          (click)="addPaymentSplitRow()"
          [disabled]="bookingBusy"
        >
          <i class="pi pi-plus" aria-hidden="true"></i>
          {{ setLabel('addPaymentLineBtnLabel') }}
        </button>
        <div
          class="bt-split-allocated"
          [class.is-valid]="isSplitAllocationValid()"
          [class.is-invalid]="!isSplitAllocationValid()"
        >
          {{ setLabel('allocatedLabel') }}:
          {{ allocatedSplitTotal | number:'1.0-0' }} /
          {{ splitAllocationTarget | number:'1.0-0' }}
        </div>
        <div class="bt-fee-error" *ngIf="splitValidationMessage">{{
          splitValidationMessage
        }}</div>
      </div>

      <div class="bt-fee-summary">
        <div
          class="bt-fee-summary-row bt-fee-summary-row--tax"
          *ngIf="!hideTaxInfo && (bookTaxType === 'WITH_TAX' || splitTotalTax > 0)"
        >
          <span>{{ setLabel('feeTaxLabel') }}</span>
          <span class="bt-fee-tax-value">{{
            multiplePaymentModesEnabled ? splitTotalTax : bookTax
          }}</span>
        </div>
        <div class="bt-fee-summary-row bt-fee-summary-row--total">
          <span>{{ setLabel('feeTotalLabel') }}</span>
          <span class="bt-fee-total">{{ bookThisPaymentTotal }}</span>
        </div>
        <div
          class="bt-fee-summary-row bt-fee-summary-row--balance"
          *ngIf="bookBalanceRemaining > 0"
        >
          <span>{{ setLabel('balanceRemainingLabel') }}</span>
          <span class="bt-fee-balance">{{ bookBalanceRemaining }}</span>
        </div>
        <p
          class="bt-fee-including-note"
          *ngIf="!hideTaxInfo && bookTaxType === 'INCLUDING_TAX'"
        >
          {{ setLabel('taxIncludingInFeeLabel') }}
        </p>
      </div>

      <div class="bt-publish-row bt-receipt-row" *ngIf="needsBookReceipt()">
        <label>{{ setLabel('uploadReceiptBtnLabel') }}</label>
        <label class="bt-receipt-drop" for="btReceipt">
          <i class="pi pi-upload" aria-hidden="true"></i>
          <span>{{ selectedReceiptName || setLabel('uploadReceiptBtnLabel') }}</span>
        </label>
        <input
          id="btReceipt"
          class="bt-receipt-input"
          type="file"
          accept="image/*,application/pdf"
          (change)="onReceiptSelected($event)"
          [disabled]="bookingBusy || receiptUploading"
        />
      </div>

      <div class="bt-publish-row">
        <label for="btComment">{{ setLabel('feeCommentLabel') }}</label>
        <textarea
          id="btComment"
          class="bt-fee-comment-input"
          rows="2"
          [(ngModel)]="bookComment"
          [disabled]="bookingBusy"
          [placeholder]="setLabel('feeCommentPlaceholderLabel')"
        ></textarea>
      </div>
    </section>

    <div class="bt-publish-actions">
      <button
        pButton
        type="button"
        class="p-button-secondary p-button-sm bt-clay-btn"
        (click)="closeBookDialog()"
        [disabled]="bookingBusy || receiptUploading"
      >{{ setLabel('closeDayLabel') }}</button>
      <button
        pButton
        type="button"
        icon="pi pi-check"
        class="p-button-success p-button-sm bt-clay-btn bt-clay-btn--ok"
        (click)="confirmBookDialog()"
        [disabled]="bookConfirmDisabled"
      >{{ bookConfirmLabel }}</button>
      </div>
  </div>
</p-dialog>

  <p-dialog
    styleClass="bt-clay-dialog"
    appendTo="body"
    [header]="setLabel('payRemainingBtnLabel')"
    [(visible)]="payRemainingDialogVisible"
    [modal]="true"
    [style]="{ width: multiplePaymentModesEnabled ? '760px' : '600px' }"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closePayRemainingDialog()"
  >
    <div class="bt-book-dialog" *ngIf="payRemainingTarget as pf">
      <div class="bt-dialog-meta">
        <div class="bt-meta-col">
          <span class="bt-meta-label">{{ setLabel('sessionPackageColLabel') }}</span>
          <span class="bt-meta-value">{{ feePackageName(pf) }}</span>
        </div>
        <div class="bt-meta-col">
          <span class="bt-meta-label">{{ setLabel('balanceRemainingLabel') }}</span>
          <span class="bt-meta-value">{{ pf.balance }}</span>
        </div>
      </div>

      <section class="bt-fee-form">
        <div class="bt-publish-row">
          <label for="btPrPayNow">{{ setLabel('feeBaseLabel') }}</label>
          <input
            id="btPrPayNow"
            type="number"
            class="bt-fee-input"
            [class.bt-fee-input--error]="payRemainingPayNowError"
            [(ngModel)]="payRemainingPayNow"
            (ngModelChange)="onPayRemainingPayNowChange()"
            min="1"
            [max]="pf.balance"
            [disabled]="payRemainingBusy"
          />
          <small class="bt-fee-error" *ngIf="payRemainingPayNowError">{{
            setLabel('feegreaterLabel')
          }}</small>
        </div>

        <div class="bt-publish-row bt-multipay-toggle">
          <label>{{ setLabel('multiplePaymentModesLabel') }}</label>
          <p-inputSwitch
            name="prMultiplePaymentModes"
            [(ngModel)]="multiplePaymentModesEnabled"
            (onChange)="onMultiplePaymentModesToggle($event.checked)"
            [disabled]="payRemainingBusy"
          ></p-inputSwitch>
        </div>

        <div class="bt-publish-row" *ngIf="!multiplePaymentModesEnabled">
          <label for="btPrPay">{{ setLabel('feePaymentModeLabel') }}</label>
          <p-dropdown
            id="btPrPay"
            class="bt-pkg-dd"
            [options]="paymentOptions"
            [(ngModel)]="payRemainingPaymentMode"
            (onChange)="onPayRemainingPaymentModeChange()"
            appendTo="body"
            [style]="{ width: '100%' }"
            [disabled]="payRemainingBusy"
          ></p-dropdown>
        </div>

        <div class="bt-split-section" *ngIf="multiplePaymentModesEnabled">
          <div class="bt-split-header">
            <span>{{ setLabel('paymentColumnLabel') }}</span>
            <span>{{ setLabel('amountLabel') }}</span>
            <span>{{ setLabel('feeTaxLabel') }}</span>
            <span>{{ setLabel('subTotalLabel') }}</span>
            <span></span>
          </div>
          <div
            class="bt-split-row"
            *ngFor="let row of paymentSplits; trackBy: trackSplitRowById"
          >
            <p-dropdown
              class="bt-pkg-dd bt-split-mode-dd"
              [options]="paymentOptions"
              [(ngModel)]="row.paymentMode"
              appendTo="body"
              [placeholder]="setLabel('feePaymentModeLabel')"
              (onChange)="onSplitPaymentModeChange(row, $event?.value ?? row.paymentMode)"
              [disabled]="payRemainingBusy"
            ></p-dropdown>
            <input
              type="number"
              class="bt-fee-input bt-split-amount"
              [ngModel]="row.pay"
              min="0"
              [placeholder]="setLabel('amountLabel')"
              (ngModelChange)="onSplitPayChange(row, $event)"
              [disabled]="payRemainingBusy"
            />
            <span class="bt-split-tax bt-readonly-pill">
              <ng-container *ngIf="row.taxType === 'INCLUDING_TAX' && row.includedTax">
                {{ row.includedTax | number:'1.0-0' }}
              </ng-container>
              <ng-container *ngIf="row.taxType !== 'INCLUDING_TAX' || !row.includedTax">
                {{ row.tax | number:'1.0-0' }}
              </ng-container>
            </span>
            <span class="bt-split-total">{{ row.lineTotal | number:'1.0-0' }}</span>
            <button
              type="button"
              class="bt-split-remove"
              (click)="removePaymentSplitRow(row.id)"
              [disabled]="paymentSplits.length <= 2 || payRemainingBusy"
              [pTooltip]="
                paymentSplits.length <= 2
                  ? setLabel('minTwoPaymentModesTooltipLabel')
                  : setLabel('removePaymentModeTooltipLabel')
              "
              tooltipPosition="top"
              aria-label="Remove"
            >
              <i class="pi pi-times" aria-hidden="true"></i>
            </button>
          </div>
          <button
            type="button"
            class="bt-split-add"
            (click)="addPaymentSplitRow()"
            [disabled]="payRemainingBusy"
          >
            <i class="pi pi-plus" aria-hidden="true"></i>
            {{ setLabel('addPaymentLineBtnLabel') }}
          </button>
          <div
            class="bt-split-allocated"
            [class.is-valid]="isSplitAllocationValid()"
            [class.is-invalid]="!isSplitAllocationValid()"
          >
            {{ setLabel('allocatedLabel') }}:
            {{ allocatedSplitTotal | number:'1.0-0' }} /
            {{ splitAllocationTarget | number:'1.0-0' }}
          </div>
          <div class="bt-fee-error" *ngIf="splitValidationMessage">{{
            splitValidationMessage
          }}</div>
        </div>

        <div class="bt-fee-summary">
          <div
            class="bt-fee-summary-row bt-fee-summary-row--tax"
            *ngIf="!hideTaxInfo && (bookTaxType === 'WITH_TAX' || splitTotalTax > 0)"
          >
            <span>{{ setLabel('feeTaxLabel') }}</span>
            <span class="bt-fee-tax-value">{{
              multiplePaymentModesEnabled ? splitTotalTax : bookTax
            }}</span>
          </div>
          <div class="bt-fee-summary-row bt-fee-summary-row--total">
            <span>{{ setLabel('feeTotalLabel') }}</span>
            <span class="bt-fee-total">{{ bookThisPaymentTotal }}</span>
          </div>
          <div
            class="bt-fee-summary-row bt-fee-summary-row--balance"
            *ngIf="bookBalanceRemaining > 0"
          >
            <span>{{ setLabel('balanceRemainingLabel') }}</span>
            <span class="bt-fee-balance">{{ bookBalanceRemaining }}</span>
          </div>
          <p
            class="bt-fee-including-note"
            *ngIf="!hideTaxInfo && bookTaxType === 'INCLUDING_TAX'"
          >
            {{ setLabel('taxIncludingInFeeLabel') }}
          </p>
        </div>

        <div class="bt-publish-row bt-receipt-row" *ngIf="needsPayRemainingReceipt()">
          <label>{{ setLabel('uploadReceiptBtnLabel') }}</label>
          <label class="bt-receipt-drop" for="btPrReceipt">
            <i class="pi pi-upload" aria-hidden="true"></i>
            <span>{{ selectedReceiptName || setLabel('uploadReceiptBtnLabel') }}</span>
          </label>
          <input
            id="btPrReceipt"
            class="bt-receipt-input"
            type="file"
            accept="image/*,application/pdf"
            (change)="onReceiptSelected($event)"
            [disabled]="payRemainingBusy || receiptUploading"
          />
        </div>

        <div class="bt-publish-row">
          <label for="btPrComment">{{ setLabel('feeCommentLabel') }}</label>
          <textarea
            id="btPrComment"
            class="bt-fee-comment-input"
            rows="2"
            [(ngModel)]="bookComment"
            [disabled]="payRemainingBusy"
            [placeholder]="setLabel('feeCommentPlaceholderLabel')"
          ></textarea>
        </div>
      </section>

      <div class="bt-publish-actions">
        <button
          pButton
          type="button"
          class="p-button-secondary p-button-sm bt-clay-btn"
          (click)="closePayRemainingDialog()"
          [disabled]="payRemainingBusy || receiptUploading"
        >{{ setLabel('closeDayLabel') }}</button>
        <button
          pButton
          type="button"
          icon="pi pi-check"
          class="p-button-success p-button-sm bt-clay-btn bt-clay-btn--ok"
          (click)="confirmPayRemaining()"
          [disabled]="payRemainingConfirmDisabled"
        >{{ setLabel('payRemainingBtnLabel') }}</button>
      </div>
    </div>
  </p-dialog>

  <p-dialog
    styleClass="bt-clay-dialog"
    [header]="setLabel('feeCommentLabel')"
    [(visible)]="commentDialogVisible"
    [modal]="true"
    [style]="{ width: '420px' }"
    [draggable]="false"
    [resizable]="false"
    (onHide)="closeFeeCommentDialog()"
  >
    <p class="bt-fee-comment-dialog-body">
      {{ commentDialogText || setLabel('noFeeCommentLabel') }}
    </p>
    <div class="bt-publish-actions">
      <button
        pButton
        type="button"
        class="p-button-secondary p-button-sm bt-clay-btn"
        (click)="closeFeeCommentDialog()"
      >{{ setLabel('closeDayLabel') }}</button>
    </div>
  </p-dialog>

  <app-single-receipt-print
    *ngIf="printBranch"
    [company]="printCompany"
    [branch]="printBranch"
    [invoiceMessage]="invoiceMessage"
  ></app-single-receipt-print>
</div>
